import { Select } from 'antd'
import styled from 'styled-components'

export const StyledTableFooterContainer = styled.div`
  .ant-form-item {
    margin: 0;
  }
`

export const StyleSelect = styled(Select)<any>`
  &.ant-select {
    width: 80px;
  }
`
export const StyleDisplay = styled.span`
  font-weight: 600;
  margin-right: 4px;
`
